import { makeLegacyAccessService } from "./accessServiceUtils";

export const creatorAlbumAccessService = makeLegacyAccessService({
  contentType: "album",
  itemsKey: "albums",
  grantIdsKey: "albumIds",
});
